import React from 'react';
import PropTypes from 'prop-types';
import { subsitePath } from '@/subsites/address';

/**
 * Shown to an admin on a subsite visitors can't simply open: one whose link
 * is not public (visitors get a 404) or one behind a password (admins skip
 * it, visitors are asked).
 *
 * A plain anchor on purpose: a router link would land under the subsite's
 * basename instead of on the admin.
 */
function SubsiteBar({ slug, passwordProtected = false }) {
    const address = subsitePath(slug).slice(1);
    return (
        <div
            role="status"
            data-subsite-bar="true"
            className="fixed bottom-3 left-1/2 -translate-x-1/2 z-[99998] flex items-center gap-3 rounded-full bg-black/85 text-white text-sm px-4 py-2 shadow-lg whitespace-nowrap"
        >
            <span>
                {passwordProtected
                    ? <>Visitors need a password for {address}.</>
                    : <>Only you can see this. {address} isn&apos;t public.</>}
            </span>
            <a href="/admin/content" className="underline underline-offset-2 text-white">
                Open versions
            </a>
        </div>
    );
}

SubsiteBar.propTypes = {
    slug: PropTypes.string.isRequired,
    passwordProtected: PropTypes.bool,
};

export default SubsiteBar;
